// Add presentation only; Shopify Forms retains all fields, translations and events.
(() => {
  function enhanceQuote(section) {
    if (section.dataset.quoteEnhanced) return;
    const template = section.querySelector('[data-project-quote-style]');
    if (!template) return;
    section.dataset.quoteEnhanced = 'true';
    const roots = new Map();
    function applyStyles() {
      section.querySelectorAll('shopify-forms-embed').forEach(host => {
        const root = host.shadowRoot;
        if (root && !roots.has(root)) {
          const rootObserver = new MutationObserver(applyStyles);
          rootObserver.observe(root, {childList: true});
          roots.set(root, rootObserver);
        }
        if (root && !root.querySelector('[data-vanecrafts-quote-style]')) {
          root.appendChild(template.content.cloneNode(true));
        }
      });
    }
    applyStyles();
    const observer = new MutationObserver(applyStyles);
    observer.observe(section, {childList: true, subtree: true});
    customElements.whenDefined('shopify-forms-embed').then(applyStyles);
    const onUnload = event => {
      if (event.target.contains(section)) {
        observer.disconnect();
        roots.forEach(rootObserver => rootObserver.disconnect());
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    };
    document.addEventListener('shopify:section:unload', onUnload);
  }
  function init() { document.querySelectorAll('.project-quote').forEach(enhanceQuote); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
